import { render, staticRenderFns } from "./DownloadSection.vue?vue&type=template&id=1d42659e&"
import script from "./DownloadSection.vue?vue&type=script&lang=js&"
export * from "./DownloadSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports